const experienceLevels = [
  {
    id: "NEW_GRAD",
    label: 'New Grads (specifically marked)',
    color: '#c4ecff',
    textColor: '#000',
  },
  {
    id: "JUNIOR",
    label: 'Juniors or switchers (0-1 YOE, not new grads)',
    color: '#c1f5f0',
    textColor: '#000',
  }, 
  {
    id: "EXPERIENCED",
    label: 'Experienced (2+ YOE required)',
    color: '#7c37ef',
    textColor: '#fff',
  }, 
  {
    id: "UNSPECIFIED",
    label: 'No experience level specified',
    color: '#ffeab6',
    textColor: '#000',
  }, 
]

export default experienceLevels
